import { AddGiftCardModal } from 'features/payment/account';

export default function AddGiftCard() {
  return <AddGiftCardModal />;
}
